//Component imports
import { CButton, CFormLabel } from '@coreui/react';
import React from 'react';

//File imports
import { Language } from '../../language/English';
import { StringUtils } from '../../pages/DocumentTemplateTranslation/Types/types';
import { string } from 'yup';

interface FieldHeadingWithHintTextProps {
    heading: string;
    openModal: () => void;
    stringUtils: StringUtils;
}

const FieldHeadingWithHintText: React.FC<FieldHeadingWithHintTextProps> = ({
    heading,
    openModal,
    stringUtils,
}) => {
    return (
        <div className="d-flex align-items-center justify-content-between mt-3">
            <CFormLabel
                htmlFor={stringUtils.convertToCamelCase(heading)}
                style={{ marginBottom: 0 }}
            >
                {heading}
            </CFormLabel>

            <CButton
                color="link"
                size="sm"
                className="text-decoration-none p-0 fs-mobile-8 text-end"
                onClick={openModal}
            >
                {Language.WHERE_IS_THIS_SHOWN}
            </CButton>
        </div>
    );
};

export default FieldHeadingWithHintText;
